import React, { useState } from 'react'
import { DataGrid } from '@mui/x-data-grid';
import dataGridStyle from '../../styles/dataGridStyle';
import TableRowActions from '../TableRowActions';
import borderStyle from '../../styles/borderStyle';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TextField,
    Button,
    Select, MenuItem,
    Box, Grid, Typography
} from '@mui/material';
import tableStyle from '../../styles/tableStyle';
import buttonStyle from '../../styles/buttonStyle';
import RowDelete from '../RowDelete';

// import { SpaceBar } from '@mui/icons-material';

const firstRow = {
    id: 1,
    description: ''
}



function Complaint() {
    const [rows, setRows] = useState([firstRow])
    const [hoveredRow, setHoveredRow] = useState(null);

    const handleRowMouseEnter = (rowId) => {
        setHoveredRow(rowId);
    };

    const handleRowMouseLeave = () => {
        setHoveredRow(null);
    };

    const columns = [
        { id: 'id', label: 'No' },
        { id: 'description', label: 'Description' },
    ];

    const handleFieldChange = (e, id, field) => {
        const updatedRows = rows.map((row) => {
            if (row.id === id) {
                return { ...row, [field]: e.target.value };
            }
            return row;
        });
        setRows(updatedRows);
    };


    return (

        <TableContainer component={Paper}>
        <Table stickyHeader aria-label="sticky table" size="small" sx={{ minWidth: 1000 }}>
            <TableHead>
                <TableRow>
                    {columns.map((column) => (
                        <TableCell key={column.id} style={column.id === 'description' ? { width: 1500 } : { width: 100 }}>
                            <b>{column.label}</b>
                        </TableCell>
                    ))}
                    <TableCell></TableCell> {/* Placeholder for delete button column */}
                </TableRow>
            </TableHead>
            <TableBody>
                {rows.map((row) => (
                    <TableRow key={row.id} onMouseEnter={() => handleRowMouseEnter(row.id)} onMouseLeave={() => handleRowMouseLeave(row.id)}>
                        <TableCell>{row.id}</TableCell>
                        <TableCell>
                            <TextField
                                fullWidth
                                variant="outlined"
                                size="small"
                                value={row.description}
                                onChange={(e) => handleFieldChange(e, row.id, 'description')}
                            />
                        </TableCell>
                      
                        <TableCell>
                        <TableRowActions rows={rows} params={row} setRows={setRows} firstRow={firstRow} field= 'description' hoveredRow={hoveredRow}/>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </TableContainer>

    )
}

export default Complaint